// TODO: Remove TileItem with old design and replace
import { memo, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { formatDuration } from "utils/parseNumber";
import { Image } from "components";
import { metrics, ViewRegion } from "utils/metrics";
import { clsx } from "clsx";
import { ViewButton, ViewButtonType } from "components/buttons/ViewButton";
import SealCheckIcon from "components/icons/bold/seal-check.svg?react";
import CarouselIcon from "components/icons/linear/carousel.svg?react";
import "./GifTile.scss";

interface IGifTile {
  thumbnail: string;
  imageAlt: string;
  video: string | undefined;
  verified: boolean;
  link: string;
  views: number;
  duration: number;
  gallery: boolean;
  index: number;
  source: ViewRegion;
  isVertical?: boolean;
}

export const GifTile: React.FC<IGifTile> = memo(({
  video,
  gallery,
  index,
  source,
  duration,
  verified,
  imageAlt,
  thumbnail,
  views,
  link,
  isVertical
}) => {
  const [isHover, setHover] = useState<boolean>(false);

  // TODO: later implement manage functionality for new gif tile component
  const onLinkClick = useCallback(async (e: React.MouseEvent<HTMLAnchorElement>) => {
    await metrics.sendGifClick({ position: index, source });
  }, [index, source]);

  const handleMouseEnter = useCallback(() => setHover(true), []);
  const handleMouseLeave = useCallback(() => setHover(false), []);

  const isVideoAvailable = isHover && Boolean(video);

  return (
    <Link
      to={link}
      className={clsx({
        "GifTile": true,
        "GifTile_isImage": !video,
        "GifTile_isVertical": isVertical,
        "GifTile_isVideo": !!video,
      })}
      onClick={onLinkClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Image
        className="GifTile-Thumbnail"
        alt={imageAlt}
        src={thumbnail}
      />

      {isVideoAvailable && (
        <video
          className={clsx({
            "GifTile-Video": true,
            "GifTile-Video_isReady": isVideoAvailable,
          })}
          data-testid="player"
          autoPlay
          loop
          playsInline
          preload="auto"
          muted
        >
          <source src={video} type="video/mp4" />
        </video>
      )}

      {views > 0 && (
        <div className="GifTile-Views">
          <ViewButton type={video ? ViewButtonType.VIDEO : ViewButtonType.IMAGE} count={views} />
        </div>
      )}

      {duration && (
        <div className="GifTile-Duration">
          {formatDuration(duration)}
        </div>
      )}

      {gallery && (
        <div className="GifTile-GalleryIcon">
          <CarouselIcon />
        </div>
      )}

      {verified && (
        <div className="GifTile-VerifiedIcon" title="Verified user">
          <SealCheckIcon />
        </div>
      )}
    </Link>
  );
});
